<script setup>
import { reactive, watch } from 'vue';
import { message } from 'ant-design-vue';
import { updateOrderInvoiceInfo } from '@/api/products/orders';

const props = defineProps({
    open: Boolean,
    order: {
        type: Object,
        default: null
    }
});

const emit = defineEmits(['update:open', 'success']);

const form = reactive({
    vat_number: '',
    invoice_title: '',
    carrier_code: ''
});

const loading = reactive({
    submit: false
});

// 當 Modal 開啟時，根據現有訂單資料初始化表單
watch(
    () => props.open,
    (newVal) => {
        if (newVal && props.order) {
            form.vat_number =
                props.order.vat_number || props.order.invoice?.vat_number || '';
            form.invoice_title = props.order.invoice_title || '';
            form.carrier_code =
                props.order.carrier_code ||
                props.order.invoice?.carrier_code ||
                '';
        }
    }
);

const handleCancel = () => {
    emit('update:open', false);
};

const handleOk = async () => {
    if (!props.order) return;

    const payload = {
        vat_number: form.vat_number?.trim() || null,
        invoice_title: form.invoice_title?.trim() || null,
        carrier_code: form.carrier_code?.trim() || null
    };

    try {
        loading.submit = true;
        const res = await updateOrderInvoiceInfo(props.order.id, payload);
        if (res && res.result !== false) {
            message.success('發票資訊更新成功');
            emit('success');
            emit('update:open', false);
        }
    } catch (err) {
        message.error(err?.response?.data?.message || '更新失敗');
    } finally {
        loading.submit = false;
    }
};
</script>

<template>
    <a-modal
        :open="open"
        title="編輯發票資訊"
        :width="480"
        :confirm-loading="loading.submit"
        ok-text="儲存"
        cancel-text="取消"
        @ok="handleOk"
        @cancel="handleCancel"
        centered
        class="vaporwave-modal"
    >
        <a-form layout="vertical" class="mt-4">
            <a-form-item label="統一編號">
                <a-input
                    v-model:value="form.vat_number"
                    placeholder="請輸入 8 位數字統一編號"
                    :maxlength="20"
                    allow-clear
                />
            </a-form-item>
            <a-form-item label="發票抬頭">
                <a-input
                    v-model:value="form.invoice_title"
                    placeholder="三聯式公司名稱（選填）"
                    :maxlength="100"
                    allow-clear
                />
            </a-form-item>
            <a-form-item label="載具 / 捐贈碼">
                <a-input
                    v-model:value="form.carrier_code"
                    placeholder="例如：/ABC1234 或 捐贈碼"
                    :maxlength="64"
                    allow-clear
                />
            </a-form-item>
        </a-form>
    </a-modal>
</template>

<style scoped>
:deep(.ant-form-item-label > label) {
    color: #2a2a3a !important;
    font-weight: 600 !important;
    font-family: 'Courier New', monospace !important;
}
</style>
